import { Pipe, PipeTransform } from '@angular/core';
import { Column } from '../models/column';
import { ValueField } from '../models/valuefield';
import { Group } from '../models/group';

@Pipe({ name: 'sortBy' })
export class SortPipe implements PipeTransform {
    transformObj(array: Array<any>, args: string): Array<any> {
        if (array !== undefined) {
            array.sort((a: any, b: any) => {
                if (a[args] < b[args]) {
                    return -1;
                } else if (a[args] > b[args]) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }
        return array;
    }

    transformGroup(array: Array<Group>, args: string): Array<Group> {
        if (array !== undefined) {
            array.sort((a: any, b: any) => {
                if (a[args] < b[args]) {
                    return -1;
                } else if (a[args] > b[args]) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }
        return array;
    }

    transform(array: Array<Column>, args: string): Array<Column> {
        if (array !== undefined) {
            array.sort((a: any, b: any) => {
                if (a[args] < b[args]) {
                    return -1;
                } else if (a[args] > b[args]) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }
        return array;
    }

    transformDate(array: Array<Date>, arg: string): Array<Date> {
        if (arg !== '') {
            let tArray = [...array];
            tArray = tArray.sort(function (a, b) { return a.getTime() - b.getTime(); });
            if (arg === 'desc') {
                tArray = tArray.reverse();
            }
            return tArray;
        }
        return array;
    }

    transformString(array: Array<string>, arg: string): Array<string> {
        if (arg !== '') {
            let tArray = [...array];
            tArray = tArray.sort();
            if (arg === 'desc') {
                tArray = tArray.reverse();
            }
            return tArray;
        }
        return array;
    }

    transformValues(array: Array<ValueField>, args: string): Array<ValueField> {
        if (array !== undefined) {
            array.sort((a: any, b: any) => {
                if (a.column[args] < b.column[args]) {
                    return -1;
                } else if (a.column[args] > b.column[args]) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }
        return array;
    }

    transformfields(array: any, args: any): Array<any> {
        args = args || {};

        const KL = this.obLen(args);

        if (!KL) {
            return array.sort(this.keySort);
        }
        // tslint:disable-next-line:forin
        for (const k in args) {
            // asc unless desc or skip
            args[k] =
                args[k] === 'desc' || args[k] === -1 ? -1
                    : (args[k] === 'skip' || args[k] === 0 ? 0
                        : 1);
        }

        array.sort((a: any, b: any) => {
            let sorted = 0, ix = 0;
            while (sorted === 0 && ix < KL) {
                const k = this.obIx(args, ix);
                if (k) {
                    const dir = args[k];
                    sorted = this.keySort(a[k], b[k], dir);
                    ix++;
                }
            }
            return sorted;
        });

        return array;
    }

    obLen(obj: any) {
        let size = 0, key;
        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                size++;
            }
        }
        return size;
    }

    obIx(obj: any, ix: any) {
        let size = 0, key;
        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (size === ix) {
                    return key;
                }
                size++;
            }
        }
        return false;
    }

    keySort(a: any, b: any, d: any) {
        d = d !== null ? d : 1;
        // a = a.toLowerCase(); // this breaks numbers
        // b = b.toLowerCase();
        if (a === b) {
            return 0;
        }
        return a > b ? 1 * d : -1 * d;
    }
}
